export default __webpack_public_path__ + "static/media/doctor-3.f34b31ba.PNG";